module.exports = __webpack_public_path__ + "static/media/smile.890ce58f.svg";